import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
    ConfirmForm,
    DataSelect,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffOrdersSetReady from '../orders/TaroffOrdersSetReady';
import TaroffOrdersEdit from '../orders/TaroffOrdersEdit';
import TaroffOrdersSetCancel from '../orders/TaroffOrdersSetCancel';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import { postData, API_URL } from '../../Api';

export default function TaroffOrders(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    
    // Add a simple reloadFlag state to trigger table data refresh
    const [reloadFlag, setReloadFlag] = useState(0);
    
    // Function to reload table data
    const reloadTableData = () => {
        setReloadFlag(prev => prev + 1);
    };
    
    // Handler to close modal and reload data
    const handleDismiss = () => {
        setModal(null);
        reloadTableData();
    };
    
    const excelButtonClick = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-id': filterQId,
            'q-shop-code': filterQShopCode,
            'q-shop-id': filterQShopId,
            'q-gateway-key-new': filterQGatewayKeyNew,
            'q-gateway-id': filterQGatewayId,
            'q-state-id': filterQStateId,
            'q-payment-method-id': filterQPaymentMethodId,
            'q-carrier-id': filterQCarrierId,
            'q-province-id': filterQProvinceId,
            'q-city-id': filterQCityId,
            'q-packet-type-id': filterQPacketTypeId,
            'q-title': filterQTitle,
            'q-customer-name': filterQCustomerName,
            'q-received-message': filterQReceivedMessage,
            'q-post-barcode': filterQPostBarcode,
            'q-address': filterQAddress,
            'q-post-code': filterQPostCode,
            'q-customer-mobile': filterQCustomerMobile,
            'q-insert-time-from': filterQInsertTimeFrom,
            'q-insert-time-to': filterQInsertTimeTo,
            'q-update-time-from': filterQUpdateTimeFrom,
            'q-update-time-to': filterQUpdateTimeTo,
            'q-last-state-change-time-from': filterQLastStateChangeTimeFrom,
            'q-last-state-change-time-to': filterQLastStateChangeTimeTo,
            'q-pre-print-status': filterQPrePrintStatus,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-orders/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-shop-id').then((response) => {
            setFormQShopIdOptions(response.data);
        });
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-state-id').then((response) => {
            setFormQStateIdOptions(response.data);
        });
    }, []);
    const [formQPaymentMethodIdOptions, setFormQPaymentMethodIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-payment-method-id').then(
            (response) => {
                setFormQPaymentMethodIdOptions(response.data);
            }
        );
    }, []);
    const [formQCarrierIdOptions, setFormQCarrierIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-carrier-id').then((response) => {
            setFormQCarrierIdOptions(response.data);
        });
    }, []);
    const [formQProvinceIdOptions, setFormQProvinceIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-province-id').then((response) => {
            setFormQProvinceIdOptions(response.data);
        });
    }, []);
    const [formQCityIdOptions, setFormQCityIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-city-id').then((response) => {
            setFormQCityIdOptions(response.data);
        });
    }, []);
    const [formQPacketTypeIdOptions, setFormQPacketTypeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/select-data/q-packet-type-id').then(
            (response) => {
                setFormQPacketTypeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp3 = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-id': filterQId,
            'q-shop-code': filterQShopCode,
            'q-shop-id': filterQShopId,
            'q-gateway-key-new': filterQGatewayKeyNew,
            'q-gateway-id': filterQGatewayId,
            'q-state-id': filterQStateId,
            'q-payment-method-id': filterQPaymentMethodId,
            'q-carrier-id': filterQCarrierId,
            'q-province-id': filterQProvinceId,
            'q-city-id': filterQCityId,
            'q-packet-type-id': filterQPacketTypeId,
            'q-title': filterQTitle,
            'q-customer-name': filterQCustomerName,
            'q-received-message': filterQReceivedMessage,
            'q-post-barcode': filterQPostBarcode,
            'q-address': filterQAddress,
            'q-post-code': filterQPostCode,
            'q-customer-mobile': filterQCustomerMobile,
            'q-insert-time-from': filterQInsertTimeFrom,
            'q-insert-time-to': filterQInsertTimeTo,
            'q-update-time-from': filterQUpdateTimeFrom,
            'q-update-time-to': filterQUpdateTimeTo,
            'q-last-state-change-time-from': filterQLastStateChangeTimeFrom,
            'q-last-state-change-time-to': filterQLastStateChangeTimeTo,
            'q-pre-print-status': filterQPrePrintStatus,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-orders/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const handlecomp4 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopCode('');
        setFilterQShopId('');
        setFilterQGatewayKeyNew('');
        setFilterQGatewayId('');
        setFilterQStateId('');
        setFilterQPaymentMethodId('');
        setFilterQCarrierId('');
        setFilterQProvinceId('');
        setFilterQCityId('');
        setFilterQPacketTypeId('');
        setFilterQTitle('');
        setFilterQCustomerName('');
        setFilterQReceivedMessage('');
        setFilterQPostBarcode('');
        setFilterQAddress('');
        setFilterQPostCode('');
        setFilterQCustomerMobile('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQUpdateTimeFrom('');
        setFilterQUpdateTimeTo('');
        setFilterQLastStateChangeTimeFrom('');
        setFilterQLastStateChangeTimeTo('');
        setFilterQPrePrintStatus('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopCode && (newSearchParams['q-shop-code'] = filterQShopCode);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQGatewayKeyNew && (newSearchParams['q-gateway-key-new'] = filterQGatewayKeyNew);
        filterQGatewayId && (newSearchParams['q-gateway-id'] = filterQGatewayId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        filterQPaymentMethodId && (newSearchParams['q-payment-method-id'] = filterQPaymentMethodId);
        filterQCarrierId && (newSearchParams['q-carrier-id'] = filterQCarrierId);
        filterQProvinceId && (newSearchParams['q-province-id'] = filterQProvinceId);
        filterQCityId && (newSearchParams['q-city-id'] = filterQCityId);
        filterQPacketTypeId && (newSearchParams['q-packet-type-id'] = filterQPacketTypeId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQReceivedMessage && (newSearchParams['q-received-message'] = filterQReceivedMessage);
        filterQPostBarcode && (newSearchParams['q-post-barcode'] = filterQPostBarcode);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        filterQPostCode && (newSearchParams['q-post-code'] = filterQPostCode);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQUpdateTimeFrom && (newSearchParams['q-update-time-from'] = filterQUpdateTimeFrom);
        filterQUpdateTimeTo && (newSearchParams['q-update-time-to'] = filterQUpdateTimeTo);
        filterQLastStateChangeTimeFrom &&
            (newSearchParams['q-last-state-change-time-from'] = filterQLastStateChangeTimeFrom);
        filterQLastStateChangeTimeTo &&
            (newSearchParams['q-last-state-change-time-to'] = filterQLastStateChangeTimeTo);
        filterQPrePrintStatus && (newSearchParams['q-pre-print-status'] = filterQPrePrintStatus);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopCode, setFilterQShopCode] = useState(allProps['q-shop-code'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQGatewayKeyNew, setFilterQGatewayKeyNew] = useState(
        allProps['q-gateway-key-new'] || ''
    );
    const [filterQGatewayId, setFilterQGatewayId] = useState(
        allProps['q-gateway-id'] || ''
    );
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    const [filterQPaymentMethodId, setFilterQPaymentMethodId] = useState(
        allProps['q-payment-method-id'] || ''
    );
    const [filterQCarrierId, setFilterQCarrierId] = useState(allProps['q-carrier-id'] || '');
    const [filterQProvinceId, setFilterQProvinceId] = useState(allProps['q-province-id'] || '');
    const [filterQCityId, setFilterQCityId] = useState(allProps['q-city-id'] || '');
    const [filterQPacketTypeId, setFilterQPacketTypeId] = useState(
        allProps['q-packet-type-id'] || ''
    );
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQReceivedMessage, setFilterQReceivedMessage] = useState(
        allProps['q-received-message'] || ''
    );
    const [filterQPostBarcode, setFilterQPostBarcode] = useState(allProps['q-post-barcode'] || '');
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    const [filterQPostCode, setFilterQPostCode] = useState(allProps['q-post-code'] || '');
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQUpdateTimeFrom, setFilterQUpdateTimeFrom] = useState(
        allProps['q-update-time-from'] || ''
    );
    const [filterQUpdateTimeTo, setFilterQUpdateTimeTo] = useState(
        allProps['q-update-time-to'] || ''
    );
    const [filterQLastStateChangeTimeFrom, setFilterQLastStateChangeTimeFrom] = useState(
        allProps['q-last-state-change-time-from'] || ''
    );
    const [filterQLastStateChangeTimeTo, setFilterQLastStateChangeTimeTo] = useState(
        allProps['q-last-state-change-time-to'] || ''
    );
    const [filterQPrePrintStatus, setFilterQPrePrintStatus] = useState(
        allProps['q-pre-print-status'] || ''
    );
    const prePrintStatusOptions = [
        { id: '', title: 'انتخاب نشده' },
        { id: 'has', title: 'دارد' },
        { id: 'not-has', title: 'ندارد' },
    ];
    useEffect(() => {
        postData('/api/panel/page/taroff-orders/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_code: filterQShopCode,
            q_shop_id: filterQShopId,
            q_gateway_key_new: filterQGatewayKeyNew,
            q_gateway_id: filterQGatewayId,
            q_state_id: filterQStateId,
            q_payment_method_id: filterQPaymentMethodId,
            q_carrier_id: filterQCarrierId,
            q_province_id: filterQProvinceId,
            q_city_id: filterQCityId,
            q_packet_type_id: filterQPacketTypeId,
            q_title: filterQTitle,
            q_customer_name: filterQCustomerName,
            q_received_message: filterQReceivedMessage,
            q_post_barcode: filterQPostBarcode,
            q_address: filterQAddress,
            q_post_code: filterQPostCode,
            q_customer_mobile: filterQCustomerMobile,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_update_time_from: filterQUpdateTimeFrom,
            q_update_time_to: filterQUpdateTimeTo,
            q_last_state_change_time_from: filterQLastStateChangeTimeFrom,
            q_last_state_change_time_to: filterQLastStateChangeTimeTo,
            q_pre_print_status: filterQPrePrintStatus,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, props, reloadFlag]);
    const handlecomp5 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersSetCancel
                        taroff-orders-id={row.param_id}
                        onDismiss={handleDismiss}
                    />
                ),
                onDismiss: handleDismiss,
            })
        );
    };
    const handlecomp6 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersSetReady
                        taroff-orders-id={row.param_id_2}
                        onDismiss={handleDismiss}
                    />
                ),
                onDismiss: handleDismiss,
            })
        );
    };
    const handlecomp7 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_3}
                        onDismiss={handleDismiss}
                    />
                ),
                onDismiss: handleDismiss,
            })
        );
    };
    const initOrder = (row) => {
        postData('/api/panel/page/taroff-orders/init-order', {
            id: row.param_id,
        }).then((response) => {
            if (response.status == 'success') {
                handleDismiss();
            }
            else {
                alert('خطایی رخ داده است');
            }
        });
    };
    const handlecomp8 = (row) => {
        setModal(
            Modal({
                children: <ConfirmForm title="در حال بررسی" text="آیا سفارش به وضعیت در حال بررسی برگردد؟" onConfirm={() => initOrder(row)} onCancel={handleDismiss} />,
                onDismiss: handleDismiss,
            })
        );
    };

    const deleteOrder = (row) => {
        postData('/api/panel/page/taroff-orders/delete-order', {
            id: row.param_id,
        }).then((response) => {
            if (response.status == 'success') {
                handleDismiss();
            }
            else {
                alert('خطایی رخ داده است');
            }
        });
    };
    const handlecomp9 = (row) => {
        setModal(
            Modal({
                children: <ConfirmForm title="حذف سفارش" text="آیا از حذف سفارش مطمئن هستید؟" onConfirm={() => deleteOrder(row)} onCancel={handleDismiss} />,
                onDismiss: handleDismiss,
            })
        );
    };
    const handlecomp10 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersEdit
                        taroff-orders-id={row.param_id_4}
                        onDismiss={handleDismiss}
                    />
                ),
                onDismiss: handleDismiss,
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت سفارشات</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={excelButtonClick} color={'secondary'}>
                        اکسل
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'شناسه'}
                    value={filterQId}
                    onChange={setFilterQId}
                    width={'60px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کد رهگیری در فروشگاه'}
                    value={filterQShopCode}
                    onChange={setFilterQShopCode}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کلید گیت وی جدید'}
                    value={filterQGatewayKeyNew}
                    onChange={setFilterQGatewayKeyNew}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کلید گیت وی'}
                    value={filterQGatewayId}
                    onChange={setFilterQGatewayId}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQStateIdOptions}
                    value={filterQStateId}
                    onChange={setFilterQStateId}
                />
                <MultiSelectBox
                    label={'شیوه ی پرداخت'}
                    options={formQPaymentMethodIdOptions}
                    value={filterQPaymentMethodId}
                    onChange={setFilterQPaymentMethodId}
                />
                <MultiSelectBox
                    label={'حامل'}
                    options={formQCarrierIdOptions}
                    value={filterQCarrierId}
                    onChange={setFilterQCarrierId}
                />
                <MultiSelectBox
                    label={'استان'}
                    options={formQProvinceIdOptions}
                    value={filterQProvinceId}
                    onChange={setFilterQProvinceId}
                />
                <MultiSelectBox
                    label={'شهر'}
                    options={formQCityIdOptions}
                    value={filterQCityId}
                    onChange={setFilterQCityId}
                />
                <MultiSelectBox
                    label={'نوع بسته'}
                    options={formQPacketTypeIdOptions}
                    value={filterQPacketTypeId}
                    onChange={setFilterQPacketTypeId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'نام خریدار'}
                    value={filterQCustomerName}
                    onChange={setFilterQCustomerName}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'پیامک دریافتی'}
                    value={filterQReceivedMessage}
                    onChange={setFilterQReceivedMessage}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'بارکد پستی'}
                    value={filterQPostBarcode}
                    onChange={setFilterQPostBarcode}
                    width={'120px'}
                />
                <DataSelect
                    label={'پریپرینت'}
                    options={prePrintStatusOptions}
                    value={filterQPrePrintStatus}
                    onChange={setFilterQPrePrintStatus}
                />
                <SearchBox onEnter={applyFilters}
                    label={'آدرس'}
                    value={filterQAddress}
                    onChange={setFilterQAddress}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کد پستی'}
                    value={filterQPostCode}
                    onChange={setFilterQPostCode}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'همراه'}
                    value={filterQCustomerMobile}
                    onChange={setFilterQCustomerMobile}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'به روز رسانی از'}
                    value={filterQUpdateTimeFrom}
                    onChange={setFilterQUpdateTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'به روز رسانی تا'}
                    value={filterQUpdateTimeTo}
                    onChange={setFilterQUpdateTimeTo}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان آخرین تغییر وضعیت از'}
                    value={filterQLastStateChangeTimeFrom}
                    onChange={setFilterQLastStateChangeTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان آخرین تغییر وضعیت تا'}
                    value={filterQLastStateChangeTimeTo}
                    onChange={setFilterQLastStateChangeTimeTo}
                    width={'100px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>خریدار</TableColumn>
                        <TableColumn mobile={false}>مبلغ کل</TableColumn>
                        <TableColumn mobile={false}>کل هزینه ارسال</TableColumn>
                        <TableColumn mobile={false}>کل مالیات ارسال</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>وضعیت </TableColumn>
                        <TableColumn mobile={false}>زمان ثبت</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_shop_id_id}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView color={row.color_shop_id_color}>
                                        {row.text_shop_id_title}
                                    </TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView>{row.text_shop_id_city_id_title}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_city_id_province_id_title}</TextView>
                                    <TextView>{row.text_3}</TextView>
                                    <TextView>{row.text_city_id_title}</TextView>
                                    <TextView>{row.text_4}</TextView>
                                    <TextView bold={true}>{row.text_customer_name}</TextView>
                                    <TextView>{row.text_5}</TextView>
                                    <TextView bold={true}>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_post_barcode}</TextView>
                                    <TextView>{row.text_pre_print_barcode}</TextView>
                                </RightComponents>
                                <TextView>{row.text_received_message}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_total_list_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_total_shipping_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_total_shipping_tax}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_carrier_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    {row.show && (
                                        <Button
                                            onClick={() => handlecomp5(row)}
                                            rightIcon={'far fa-ban'}
                                            tooltip={'لغو آماده ارسال'}
                                        ></Button>
                                    )}
                                    {row.show_2 && (
                                        <Button
                                            onClick={() => handlecomp6(row)}
                                            rightIcon={'far fa-check'}
                                            tooltip={'آماده ارسال'}
                                        ></Button>
                                    )}
                                    <Button
                                        onClick={() => handlecomp7(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'Taroff Orders View'}
                                    ></Button>
                                    {row.show_3 && (
                                        <Button
                                            onClick={() => handlecomp8(row)}
                                            rightIcon={'fal fa-clock-rotate-left'}
                                            tooltip={'در حال بررسی'}
                                        ></Button>
                                    )}
                                    {row.show_4 && (
                                        <Button
                                            onClick={() => handlecomp9(row)}
                                            rightIcon={'fal fa-trash'}
                                            tooltip={'حذف'}
                                        ></Button>
                                    )}
                                    {row.show_5 && (
                                        <Button
                                            onClick={() => handlecomp10(row)}
                                            rightIcon={'far fa-edit'}
                                            tooltip={'Taroff Orders Edit'}
                                        ></Button>
                                    )}
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
